// removed by extract-text-webpack-plugin
module.exports = {"main":"App__main___15Ir1","head":"App__head___xjkBm","navigation":"App__navigation___3oT3d","content":"App__content___3TVHp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/App.scss
// module id = 181
// module chunks = 0